import * as PIXI from "pixi.js";
import Game from "../../../../../../src/Game";
import GridArea from "../../../../../../src/entities/GridArea";
import DrawingManager from "./DrawingManager/DrawingManager";
import QuestionManager from "./QuestionManager/QuestionManager";
import { GRID_CONFIG } from "../../types/Config";


export default class GridManager extends PIXI.Container {
  private Game = Game.getInstance();
  private dim = this.Game.getDim();

  constructor() {
    super();
    const gridConfig = getGridConfig(this.dim);
    new GridArea(gridConfig);
    new DrawingManager(gridConfig);
    new QuestionManager(gridConfig);
  }
}

function getGridConfig({ WIDTH, HEIGHT }) {
  const gridConfig = { ...GRID_CONFIG };
  WIDTH < HEIGHT ? gridConfig.x = WIDTH / 2 : "";
  return gridConfig;
}